var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middlebar"},[_c('div',{staticClass:"pl-4 text-white pt-3 pb-5"},[_c('h2',{staticClass:"mt-4 text-white"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }